import {
  GET_NOTIFICATION_STATUS,
  GET_NOTIFICATION_STATUS_SUCCESS,
  GET_NOTIFICATION_STATUS_ERROR,
  GET_NOTIFICATION_STATUS_EMPTY,
} from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetNotificationStatus = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATION_STATUS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_NOTIFICATION_STATUS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_NOTIFICATION_STATUS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_NOTIFICATION_STATUS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetNotificationStatus;
